import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { t } from "ttag";

import { getDocumentQuery } from "@/app/api/legacy-api";
import { ErrorState } from "@/app/components/legacy-components";
import { consultationsQueriesStore } from "@/features/consultations/api";
import {
  PastConsultationsCards,
  PastConsultationsTable,
} from "@/features/consultations/components";
import type { Appointment } from "@/features/consultations/models";
import { History2Icon, Pagination, TableSkeleton } from "@/shared/ui";

export const PastConsultations = () => {
  const [consultationsOffset, setConsultationsOffset] = useState(0);
  const { data, isLoading, isSuccess, isError } = useQuery(
    consultationsQueriesStore.consultations.appointments._ctx.list._ctx.past._ctx.medicationRequest(
      consultationsOffset,
    ),
  );

  const consultations = data?.data ?? [];
  const pagination = data?.pagination;
  const [documentId, setDocumentId] = useState<Appointment["documentId"]>();

  const { data: documentUrl } = useQuery(getDocumentQuery(documentId));

  useEffect(() => {
    if (documentUrl) {
      window.open(documentUrl.url, "_blank");
      setDocumentId("");
    }
  }, [documentUrl]);

  return (
    <section className="flex flex-1 flex-col gap-4 pb-10 text-neutral-950">
      <h3 className="flex items-center gap-2 text-lg font-semibold">
        <History2Icon className="size-4" />
        {t`Past consultations`}
      </h3>

      {isLoading && <TableSkeleton columns={5} rows={3} />}

      {isSuccess && (
        <>
          <PastConsultationsTable
            consultations={consultations}
            setDocumentId={setDocumentId}
          />

          <PastConsultationsCards
            consultations={consultations}
            setDocumentId={setDocumentId}
          />

          {pagination && pagination.totalPages > 1 && (
            <div className="flex items-center justify-between rounded-xl border border-neutral-500 px-6 py-4 md:rounded-t-none md:rounded-b-2xl md:border-t-0">
              <Pagination
                {...pagination}
                onPageChange={(page) => {
                  setConsultationsOffset((page - 1) * pagination.perPage);
                }}
              />
            </div>
          )}
        </>
      )}

      {isError && <ErrorState />}
    </section>
  );
};
